function initWishlistButtons() {
    const elFilled = document.getElementById('svg-heart-filled');
    const elEmpty = document.getElementById('svg-heart-empty');
    if (!elFilled || !elEmpty) return;
    const heartFilledSVG = elFilled.innerHTML;
    const heartEmptySVG = elEmpty.innerHTML;

    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    const heartButtons = document.querySelectorAll('.heart-toggle');

    function openWishlistOverlay(alignment = 'center') {
        const overlay = document.getElementById('wishlist-overlay');
      
        // Reset alignment and spacing classes
        overlay.classList.remove('justify-center', 'md:justify-end', 'items-center', 'md:items-start', 'md:m-3');
      
        if (alignment === 'end') {
          overlay.classList.add('md:justify-end', 'md:items-start', 'md:p-5', 'items-center', 'justify-center',);
        } else {
          overlay.classList.add('justify-center', 'items-center');
        }
      
        // Show overlay
        overlay.classList.remove('hidden');
        overlay.classList.add('flex');
      
        // window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    // Sync hearts on page load
    heartButtons.forEach(button => {
        const id = button.dataset.id;
        const icon = button.querySelector('.heart-icon');
        const isInWishlist = wishlist.some(item => item.id === id);
        icon.innerHTML = isInWishlist ? heartFilledSVG : heartEmptySVG;
    });

    // Heart click logic
    heartButtons.forEach(button => {
        const icon = button.querySelector('.heart-icon');

        button.addEventListener('click', function (e) {
            e.preventDefault();

            const data = {
                id: button.dataset.id,
                handle: button.dataset.handle,
                title: button.dataset.title,
                image: button.dataset.image,
                price: button.dataset.price
            };

            const index = wishlist.findIndex(item => item.id === data.id);

            if (index === -1) {
                wishlist.push(data);
                icon.innerHTML = heartFilledSVG;
            } else {
                wishlist.splice(index, 1);
                icon.innerHTML = heartEmptySVG;
            }

            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            renderWishlistOverlay();
            openWishlistOverlay('center');
            updateWishlistHeading('added');
        });
    });

function updateWishlistHeading(type = 'added') {
  const heading = document.getElementById('wishlist-heading');
  const favoris = document.getElementById('vos-favoris')?.innerText.trim();
  const added = document.getElementById('added-label')?.innerText.trim();

  const label = type === 'favoris' ? favoris : added;
  heading.innerHTML = `${label} (<span id="wishlist-count">${wishlist.length}</span>)`;
}
    // Render overlay
    function renderWishlistOverlay() {
        wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const counter = document.getElementById('wishlist-count');
  counter.textContent = wishlist.length;

        const overlay = document.getElementById('wishlist-overlay');
        const container = document.getElementById('wishlist-items');
        const removeLabel = document.getElementById('removed-label')?.innerText || 'Supprimer';
        overlay.classList.remove('justify-end');
        overlay.classList.add('justify-center');
        container.innerHTML = '';
        counter.textContent = wishlist.length;

        wishlist.slice().reverse().forEach(item => {

            const itemDiv = document.createElement('div');
            itemDiv.className = 'flex justify-between items-start border-b border-ultraDark p-3 group';

            itemDiv.innerHTML = `
            <div class="flex flex-col pr-2">
              <a href='products/${item.handle}' class="md:text-d-p text-m-p mb-1 hover:underline">${item.title}</a>
              <div class='md:text-d-p text-m-p'>${item.price}</div>
              <button class="text-xs underline md:mt-7 mt-3 remove-from-wishlist text-left group-hover:opacity-60 md:opacity-0 opacity-60 hover:!opacity-100 transition-opacity" data-id="${item.id}">${removeLabel} &#x2715; </button>
            </div>
                <a href='products/${item.handle}'  class='overflow-hidden'>
              <img src="${item.image}" alt="${item.title}" class="w-auto group-hover:scale-105 transition-all md:h-20 h-16 aspect-[0.78] object-cover" />
        </a>
          `;

            container.appendChild(itemDiv);
        });

        overlay.classList.remove('hidden');
        overlay.classList.add('flex');

        document.querySelectorAll('.remove-from-wishlist').forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation(); // 💥 prevents the background click from firing

                const id = this.dataset.id;

                wishlist = wishlist.filter(item => item.id !== id);
                localStorage.setItem('wishlist', JSON.stringify(wishlist));

                document.querySelectorAll(`.heart-toggle[data-id="${id}"] .heart-icon`).forEach(icon => {
                    icon.innerHTML = heartEmptySVG;
                });

                renderWishlistOverlay();
            });
        });
    }

    // Close overlay
    document.getElementById('close-wishlist')?.addEventListener('click', () => {
        const overlay = document.getElementById('wishlist-overlay');
        overlay.classList.add('hidden');
        overlay.classList.remove('flex');
    });
    // Close overlay when clicking outside the inner box
    document.getElementById('wishlist-overlay')?.addEventListener('click', (e) => {
        const popupBox = e.currentTarget.querySelector('div.bg-light');
        if (!popupBox.contains(e.target)) {
            e.currentTarget.classList.add('hidden');
            e.currentTarget.classList.remove('flex');
        }
    });
    document.querySelectorAll('.wishlist-trigger').forEach((link) => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          renderWishlistOverlay();
          updateWishlistHeading('favoris'); // show "Vos favoris"
          openWishlistOverlay('end');
        });
      });
};

document.addEventListener('DOMContentLoaded', function () {
  initWishlistButtons();
});